/* @flow */

import { responseHasError } from '../diplomatico/reducers/helper';
import type { Action } from '../diplomatico/types';

const initialState = [];

function intelligences(state: Array<Object> = initialState, { type, payload }: Action) {
  switch (type) {
    case 'RESPONSE_INTELLIGENCES':
      if (responseHasError(payload)) {
        return state;
      }

      return payload.body
    default:
      return state;
  }
}

export {
  intelligences,
  initialState
};

export default intelligences;
